import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

const CONSENT_KEY = "kera_cookie_consent";

function applyConsent(choice) {
  try {
    localStorage.setItem(CONSENT_KEY, choice);
  } catch {}
  if (typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      analytics_storage: choice === "accepted" ? "granted" : "denied",
      ad_storage: "denied",
    });
  }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(CONSENT_KEY)) setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const choose = (choice) => {
    applyConsent(choice);
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-0 inset-x-0 z-50 px-4 pb-4 sm:px-8 sm:pb-6"
          data-testid="cookie-banner"
        >
          <div className="max-w-3xl mx-auto rounded-2xl bg-black text-white border border-white/10 shadow-2xl px-5 py-4 sm:px-7 sm:py-5 flex flex-col sm:flex-row sm:items-center gap-4">
            <Cookie className="text-kera-gold shrink-0 hidden sm:block" size={22} strokeWidth={1.5} />
            <p className="text-xs sm:text-sm text-white/70 leading-relaxed flex-1">
              We use cookies to understand how visitors use our site (Google Analytics) and to improve your experience.
              You can accept or decline — the site works either way.
            </p>
            <div className="flex items-center gap-3 shrink-0">
              <button
                onClick={() => choose("declined")}
                className="rounded-full border border-white/25 px-5 py-2 text-xs font-medium hover:border-white/60 transition-colors"
                data-testid="cookie-decline"
              >
                Decline
              </button>
              <button
                onClick={() => choose("accepted")}
                className="rounded-full bg-kera-gold text-black px-5 py-2 text-xs font-semibold hover:bg-kera-goldlight transition-colors"
                data-testid="cookie-accept"
              >
                Accept
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
